type CognitoUserError = { code: string; name: string; message: string };

export function isCognitoUserError(error: unknown): error is CognitoUserError {
  return typeof error === 'object' && error !== null && 'code' in error;
}
